import React from 'react';
import styled from 'styled-components';
import { color, borderRadius, space, fontWeight } from '@core-ds/primitives';
import withTippy from '../dropdowns/with_tippy';

const TitleContainer = styled.div`
   display: flex;
   align-items: center;
`;

const Indicator = styled.div`
   width: 4px;
   height: 30px;
   margin-right: ${space[3]};
   background: ${color.gray8};
   border-radius: ${borderRadius.sm};
   transition: background 0.2s;
`;

const Link = styled.a.attrs(props => ({
   className: 'subitem',
}))`
   display: flex;
   align-items: center;
   justify-content: space-between;

   :hover {
      text-decoration: none;

      ${Indicator} {
         background: ${color.blue};
      }
   }

   h3 {
      margin: 0;
      color: ${color.gray3};
      font-weight: ${fontWeight.normal};
   }
`;

const DropdownLink = withTippy(Link);

const FullWidthDropdownLink = styled(DropdownLink)`
   width: calc(100vw - 2 * ${space[4]});
   margin: 0 ${space[4]};
   right: 18px;
`;

const AccordionSubitem = ({ href, title, icon, dropdown, fullWidthDropdown }) => {
   let dropdownLinkProps = {
      content: dropdown,
      placement: 'top',
   };

   if (fullWidthDropdown) {
      dropdownLinkProps = {
         ...dropdownLinkProps,
         distance: 0,
         offset: '0, -280',
         maxWidth: 'none',
         placement: 'bottom',
      };
   }

   const DropdownLinkType = fullWidthDropdown ? FullWidthDropdownLink : DropdownLink;
   const LinkType = dropdown ? DropdownLinkType : Link;
   const linkProps = dropdown ? dropdownLinkProps : { href };

   return (
      <LinkType {...linkProps}>
         <TitleContainer>
            <Indicator />
            <h3>{title}</h3>
         </TitleContainer>
         {icon}
      </LinkType>
   );
};

export default AccordionSubitem;
